import { render, staticRenderFns } from "./vipinfos.vue?vue&type=template&id=349461a3&scoped=true"
import script from "./vipinfos.vue?vue&type=script&lang=js"
export * from "./vipinfos.vue?vue&type=script&lang=js"
import style0 from "./vipinfos.vue?vue&type=style&index=0&id=349461a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349461a3",
  null
  
)

export default component.exports